import plusIcon from '@src/main/assets/icons/plus.svg';
import { Button } from 'primereact/button';
import { FC, ReactNode } from 'react';
import styles from './AddButton.module.scss';

interface AddButtonProps {
  label: string;
  icon?: ReactNode;
  onClick: () => void;
}

export const AddButton: FC<AddButtonProps> = ({ label, icon, onClick }) => (
  <Button
    label={label}
    icon={icon ?? <img src={plusIcon} alt="plus" width="12" />}
    onClick={onClick}
    className={`${styles['add-button']}`}
  />
);
